class I18nHelper {
  _currentPage = {
    routeName: null,
    langParam: null,
    pageSlug: null,
    pageId: null
  };

  _translatedPage = {
    routeName: null,
    langParam: null,
    pageSlug: null,
    pageId: null
  };

  get currentPage() {
    return { ...this._currentPage };
  }

  get translatedPage() {
    return { ...this._translatedPage };
  }

  set currentPage(currentPage) {
    throw new Error("Cannot directly change the currentPage");
  }

  set translatedPage(translatedPage) {
    throw new Error("Cannot directly change the translatedPage");
  }

  setCurrentPage(routeName, langParam, pageSlug, pageId) {
    this._currentPage = { routeName, langParam, pageSlug, pageId };
  }

  setTranslatedPage(routeName, langParam, pageSlug, pageId) {
    this._translatedPage = { routeName, langParam, pageSlug, pageId };
  }
}

export const i18nHelper = new I18nHelper();
